<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="editForm" :rules="rules" ref="editForm">
          <div>
            <el-row>

              <el-col :span="12" class="item">
                <el-form-item label="机构" prop="institutionCode">
                  <el-select @change="insChange"
                      v-model="editForm.institutionCode"
                      style="width:100%"
                      placeholder="请选择机构">
                    <el-option
                        v-for="item in arr_ins"
                        :key="item.institutionCode"
                        :label="item.userName"
                        :value="item.institutionCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="评估类型" prop="checkinAssessClassCode">
                  <el-select
                      v-model="editForm.checkinAssessClassCode"
                      style="width:100%"
                      placeholder="请选择评估类型">
                    <el-option
                        v-for="item in classData"
                        :key="item.checkinAssessClassCode"
                        :label="item.name"
                        :value="item.checkinAssessClassCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="评估组名称" prop="groupName">
                  <el-input v-model="editForm.groupName" placeholder="请输入评估组名称"></el-input>
                </el-form-item>
              </el-col>


<!--              <el-col :span="12" class="item">-->
<!--                <el-form-item label="状态" prop="status">-->
<!--                  <el-select v-model="editForm.status" placeholder="请选择状态" style="width:100%">-->
<!--                    <el-option-->
<!--                        v-for="item in status2"-->
<!--                        :key="item.value"-->
<!--                        :label="item.label"-->
<!--                        :value="item.value">-->
<!--                    </el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
              <el-col :span="12" class="item">
                <el-form-item label="排序" prop="sort">
                  <el-input v-model.number="editForm.sort" placeholder="排序"></el-input>
                </el-form-item>
              </el-col>




            </el-row>

            <el-row>
              <el-col :span="24" class="item">
                <el-card class="box-card" shadow='never' :body-style='{padding:0}'>
                  <div slot="header" class="clearfix">
                    <span>评估项</span>
                    <el-button style="float: right;transform: translate(0px, -9px);" type="primary" @click="showModal">添加</el-button>
                  </div>
                  <el-table :height="150"
                      :data="itemInfo"
                      style="width: 100%" border
                      max-height="230">
                    <el-table-column
                        prop="itemName"
                        label="评估项">
                    </el-table-column>
                    <el-table-column
                        prop="fraction"
                        label="分数">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="180">
                      <template slot-scope="scope">
                        <el-button type="primary" size="small" @click.native.prevent="deleteRow(scope.$index, itemInfo)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-card>
              </el-col>
            </el-row>

          </div>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
      </div>
    </div>

    <el-dialog title='评估项添加' :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false' :modal-append-to-body='false'>
      <el-form>
        <el-form-item label="评估项名称" required style="width:100%">
          <el-input v-model="itemName" placeholder="请输入评估项名称"></el-input>
        </el-form-item>
        <el-form-item label="分数" required style="width:100%">
          <el-input v-model="fraction" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入评估分数"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary"  @click="addSub">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Edit",
  props:['arr_ins'],
  data() {
    return {

      loading: false,
      batchDialog: false,
      calculationType:1,
      pageSize: 20,
      currentPage: 1,
      assessItemInfo: [],
      itemInfo: [],
      itemName: null,
      fraction: null,

      editForm: {
        timeStr: timeStr,
        sign: '',
        staffCode: getStaffCode(),
        institutionCode:'',
        groupName: '',
        assessItemArr: [],
        sort: '',
        status:'',
        checkinAssessClassCode:'',
        checkinAssessGroupCode:''
      },

      classData:[],

      status2: [{
        value: 0,
        label: '正常'
      }, {
        value: 1,
        label: '被禁用'
      }],

      rules: {
        groupName: [
          {required: true, message: '请输入评估组名称', trigger: 'blur'},
        ],
        checkinAssessClassCode: [
          {required: true, message: '请选择评估类型', trigger: 'blur'},
        ],
        sort: [
          {required: true, message: '请输入排序', trigger: 'blur'},
          {type: 'number', message: '排序必须为数字值'}
        ],
      }



    }
  },

  methods: {

    init(row) {
      this.itemInfo=[]
      this.editForm.checkinAssessClassCode=row.checkinAssessClassCode
      this.editForm.sort=row.sort
      this.editForm.checkinAssessGroupCode=row.checkinAssessGroupCode
      this.editForm.groupName=row.name
      this.editForm.status=row.status
      this.editForm.institutionCode = row.institutionCode;

      var list=row.checkinAssessItemList
      list.forEach(element => {
        this.itemInfo.push({itemName:element.name,fraction:element.fraction})
      });

      this.getClass();

    },
    closeSelf() {
      this.$emit("closeEdit");
    },

    confirm(editForm) {
      this.$refs[editForm].validate((valid) => {
        if (valid) {
          this.addSubmit();
        } else {
          return false;
        }
      })

    },
    addSubmit() {

      if(this.itemInfo.length==0){
        this.$message.error('请添加评估项')
        return
      }
      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }

      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey);
      this.editForm.assessItemArr=this.itemInfo

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "CheckinAssessGroup/GovEdit",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            } else {
              this.$message({type: 'info', message: '添加失败'});
            }
          }
      )
    },


    showModal(){
      this.itemName=null
      this.fraction=null
      this.batchDialog=true
    },
    addSub(){
      if(!this.itemName){
        this.$message.error('请输入评估项名称')
        return
      }
      if(!this.fraction){
        this.$message.error('请输入评估分数')
        return
      }
      this.itemInfo.push({itemName:this.itemName,fraction:this.fraction})
      this.batchDialog=false
    },
    deleteRow(index, rows){
      rows.splice(index, 1);
    },


    insChange(val){
      this.editForm.institutionCode = val;

      this.classData=[];
      this.editForm.checkinAssessClassCode = '';
      this.getClass();
    },
    getClass(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "CheckinAssessClass/InsList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.editForm.institutionCode,
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.classData = response.data.data;
        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });

    },




  }
}
</script>

<style lang="scss" scoped>



</style>

